import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-51a0568a")

_pushScopeId("data-v-51a0568a")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "data second promo-event" }
const _hoisted_3 = { class: "data second promo-event" }
const _hoisted_4 = { class: "input-border first" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { for: "title" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Název promo akce", -1)
const _hoisted_7 = { class: "group" }
const _hoisted_8 = { class: "border-gr short" }
const _hoisted_9 = { class: "input-border" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "date" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Obrázek na hlavní stránce", -1)
const _hoisted_12 = { class: "group" }
const _hoisted_13 = { class: "border-gr short date" }
const _hoisted_14 = { class: "data second" }
const _hoisted_15 = { class: "input-border" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { for: "date" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Obrázek v detailu", -1)
const _hoisted_18 = { class: "group" }
const _hoisted_19 = { class: "border-gr short date" }
const _hoisted_20 = { class: "data second alert-message" }
const _hoisted_21 = { class: "input-border first" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", { for: "title" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Popis promo akce", -1)
const _hoisted_24 = { class: "group" }
const _hoisted_25 = { class: "border-gr short" }
const _hoisted_26 = { class: "data second alert-message" }
const _hoisted_27 = { class: "input-border first" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { for: "title" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Jak sleva funguje?", -1)
const _hoisted_30 = { class: "group" }
const _hoisted_31 = { class: "border-gr short" }
const _hoisted_32 = { class: "data second alert-message" }
const _hoisted_33 = { class: "input-border first" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", { for: "title" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Od kdy do kdy akce platí?", -1)
const _hoisted_36 = { class: "group" }
const _hoisted_37 = { class: "border-gr short" }
const _hoisted_38 = { class: "data second alert-message" }
const _hoisted_39 = { class: "input-border first" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { for: "title" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Odkaz na web", -1)
const _hoisted_42 = { class: "group" }
const _hoisted_43 = { class: "border-gr short" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.promoEvent !== undefined)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h2", null, "Jazyk: " + _toDisplayString(_ctx.promoEvent.lang.toUpperCase()), 1)
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("input", {
                  type: "text",
                  autocomplete: "nope",
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('set-title', _ctx.promoEvent.lang, $event.target.value))),
                  value: _ctx.promoEvent.page_title
                }, null, 40, ["value"])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _hoisted_11,
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createVNode("input", {
                  id: "file",
                  type: "file",
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectFile && _ctx.selectFile(...args)))
                }, null, 32)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _hoisted_16,
            _hoisted_17,
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode("input", {
                  id: "image_file",
                  type: "file",
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectContentImageFile && _ctx.selectContentImageFile(...args)))
                }, null, 32)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            _hoisted_22,
            _hoisted_23,
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                _createVNode("input", {
                  type: "text",
                  autocomplete: "nope",
                  onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('set-description', _ctx.promoEvent.lang, $event.target.value))),
                  value: _ctx.promoEvent.page_content_description
                }, null, 40, ["value"])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_26, [
          _createVNode("div", _hoisted_27, [
            _hoisted_28,
            _hoisted_29,
            _createVNode("div", _hoisted_30, [
              _createVNode("div", _hoisted_31, [
                _createVNode("input", {
                  type: "text",
                  autocomplete: "nope",
                  onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('set-how-to-works', _ctx.promoEvent.lang, $event.target.value))),
                  value: _ctx.promoEvent.page_content_how_to_works
                }, null, 40, ["value"])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_32, [
          _createVNode("div", _hoisted_33, [
            _hoisted_34,
            _hoisted_35,
            _createVNode("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, [
                _createVNode("input", {
                  type: "text",
                  autocomplete: "nope",
                  onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('set-date', _ctx.promoEvent.lang, $event.target.value))),
                  value: _ctx.promoEvent.page_content_date
                }, null, 40, ["value"])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_38, [
          _createVNode("div", _hoisted_39, [
            _hoisted_40,
            _hoisted_41,
            _createVNode("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, [
                _createVNode("input", {
                  type: "text",
                  autocomplete: "nope",
                  onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('set-web', _ctx.promoEvent.lang, $event.target.value))),
                  value: _ctx.promoEvent.page_content_web
                }, null, 40, ["value"])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})